import { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

export default function CustomCursor() {
  const [isVisible, setIsVisible] = useState(false);
  const [isPointer, setIsPointer] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  const mouseX = useMotionValue(-100);
  const mouseY = useMotionValue(-100);

  const springConfig = { damping: 25, stiffness: 200, mass: 0.5 };
  const ringConfig = { damping: 35, stiffness: 130, mass: 0.8 };

  const dotX = useSpring(mouseX, springConfig);
  const dotY = useSpring(mouseY, springConfig);
  const ringX = useSpring(mouseX, ringConfig);
  const ringY = useSpring(mouseY, ringConfig);

  useEffect(() => {
    // Detect touch device
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      setIsTouchDevice(true);
      return;
    }

    const handleMove = (e) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
      if (!isVisible) setIsVisible(true);
    };

    const handlePointerOver = (e) => {
      const el = e.target;
      const cursor = window.getComputedStyle(el).cursor;
      setIsPointer(cursor === 'pointer' || el.tagName === 'A' || el.tagName === 'BUTTON' || el.closest('a') || el.closest('button'));
    };

    const handleLeave = () => setIsVisible(false);
    const handleEnter = () => setIsVisible(true);

    window.addEventListener('mousemove', handleMove);
    window.addEventListener('mouseover', handlePointerOver);
    document.documentElement.addEventListener('mouseleave', handleLeave);
    document.documentElement.addEventListener('mouseenter', handleEnter);

    return () => {
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('mouseover', handlePointerOver);
      document.documentElement.removeEventListener('mouseleave', handleLeave);
      document.documentElement.removeEventListener('mouseenter', handleEnter);
    };
  }, [isVisible]);

  if (isTouchDevice) return null;

  return (
    <>
      {/* Outer ring */}
      <motion.div
        data-testid="premium-cursor"
        className="fixed pointer-events-none z-[9999] rounded-full"
        style={{
          x: ringX,
          y: ringY,
          width: isPointer ? 48 : 36,
          height: isPointer ? 48 : 36,
          border: '1px solid rgba(201,168,76,0.6)',
          backgroundColor: 'transparent',
          translateX: isPointer ? '-24px' : '-18px',
          translateY: isPointer ? '-24px' : '-18px',
          opacity: isVisible ? 1 : 0,
          transition: 'width 0.2s ease, height 0.2s ease, border-color 0.2s ease, translateX 0.2s ease, translateY 0.2s ease, opacity 0.2s ease',
        }}
      />
      {/* Inner dot */}
      <motion.div
        className="fixed pointer-events-none z-[9999] rounded-full"
        style={{
          x: dotX,
          y: dotY,
          width: isPointer ? 6 : 4,
          height: isPointer ? 6 : 4,
          backgroundColor: '#C9A84C',
          translateX: isPointer ? '-3px' : '-2px',
          translateY: isPointer ? '-3px' : '-2px',
          opacity: isVisible ? 1 : 0,
          transition: 'width 0.2s ease, height 0.2s ease, opacity 0.2s ease',
        }}
      />
    </>
  );
}
